import React from 'react';

const RefreshIcon = ({ spin = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={spin ? 'spin' : ''}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13.5V11.25L12 14.25L9 17.25V15C5.685 15 3 12.315 3 9C3 7.8225 3.345 6.7275 3.93 5.805L5.025 6.9C4.6875 7.5225 4.5 8.2425 4.5 9C4.5 11.4825 6.5175 13.5 9 13.5ZM14.07 12.195L12.975 11.1C13.305 10.47 13.5 9.7575 13.5 9C13.5 6.5175 11.4825 4.5 9 4.5L9 6.75L6 3.75L9 0.75V3C12.315 3 15 5.685 15 9C15 10.1775 14.655 11.2725 14.07 12.195Z"
        fill="black"
        fillOpacity={spin ? '1' : '0.54'}
      />
    </svg>
  );
};

export default RefreshIcon;
